//
// One place for the "save this blob to disk" anchor dance. Three call sites (ReportRequest,
// WordEvidenceExportModal, SeedForProjectModal) each grew their own copy of the same four lines;
// this is the one they now share.
//

/** Triggers a browser download of `blob` named `fileName`, through a throwaway anchor element. */
export function downloadBlob(blob: Blob, fileName: string): void {
  const anchor = window.document.createElement('a');
  anchor.href = window.URL.createObjectURL(blob);
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(anchor.href);
}

/**
 * Strips characters a filesystem would refuse and trims the result. A caller with its own
 * extension/fallback rules (e.g. `WordEvidenceExportModal`'s `.pdf` naming) applies those on top of
 * this - this function only answers the one question every caller shares: which characters cannot
 * survive as a file name.
 */
export function sanitizeFileName(fileName: string): string {
  return fileName.replace(/[<>:"/\\|?*]+/g, ' ').trim();
}
